module.exports = __webpack_public_path__ + "img/ArmadilloTextLogo_Desktop.2fb127dd.svg";